/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mobile_Notes_Add_NoteInputs */

const en_mobile_notes_add_note = /** @type {(inputs: Mobile_Notes_Add_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add note`)
};

const es_mobile_notes_add_note = /** @type {(inputs: Mobile_Notes_Add_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agregar nota`)
};

/**
* | output |
* | --- |
* | "Add note" |
*
* @param {Mobile_Notes_Add_NoteInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mobile_notes_add_note = /** @type {((inputs?: Mobile_Notes_Add_NoteInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_Notes_Add_NoteInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mobile_notes_add_note(inputs)
	return en_mobile_notes_add_note(inputs)
});